import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjInterpretationsS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 1C5.77614 1 6 1.24108 6 1.53846L6 14.4615C6 14.7589 5.77614 15 5.5 15C5.22386 15 5 14.7589 5 14.4615L5 1.53846C5 1.24108 5.22386 1 5.5 1Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1C8.77614 1 9 1.24108 9 1.53846L9 14.4615C9 14.7589 8.77614 15 8.5 15C8.22386 15 8 14.7589 8 14.4615L8 1.53846C8 1.24108 8.22386 1 8.5 1Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 1C11.7761 1 12 1.18942 12 1.42308L12 11.5769C12 11.8106 11.7761 12 11.5 12C11.2239 12 11 11.8106 11 11.5769L11 1.42308C11 1.18942 11.2239 1 11.5 1Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 4C2.77614 4 3 4.18942 3 4.42308L3 14.5769C3 14.8106 2.77614 15 2.5 15C2.22386 15 2 14.8106 2 14.5769L2 4.42308C2 4.18942 2.22386 4 2.5 4Z"
        fill="#97B2C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 6.5C1 6.22386 1.20664 6 1.46154 6L12.5385 6C12.7934 6 13 6.22386 13 6.5C13 6.77614 12.7934 7 12.5385 7L1.46154 7C1.20664 7 1 6.77614 1 6.5Z"
        fill="#32B4FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10.5C1 10.2239 1.20664 10 1.46154 10L12.5385 10C12.7934 10 13 10.2239 13 10.5C13 10.7761 12.7934 11 12.5385 11L1.46154 11C1.20664 11 1 10.7761 1 10.5Z"
        fill="#EB6D00"
      />
    </svg>
  )
}

export const IconGeoObjInterpretations = createIcon({
  l: IconGeoObjInterpretationsS,
  m: IconGeoObjInterpretationsS,
  s: IconGeoObjInterpretationsS,
  xs: IconGeoObjInterpretationsS,
  name: 'IconGeoObjInterpretations',
})
